module.exports = __webpack_public_path__ + "img/FlightLiveData.699e664e.png";